import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS, LANGS } from "../lib/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "nl";
    return window.localStorage.getItem("hcds_lang") || "nl";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("hcds_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = useMemo(() => TRANSLATIONS[lang] || TRANSLATIONS.nl, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
